/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { VerifyEmail200ResponseData } from './VerifyEmail200ResponseData'
import {
  VerifyEmail200ResponseDataFromJSON,
  VerifyEmail200ResponseDataFromJSONTyped,
  VerifyEmail200ResponseDataToJSON,
} from './VerifyEmail200ResponseData'

/**
 *
 * @export
 * @interface VerifyEmail200Response
 */
export interface VerifyEmail200Response {
  /**
   *
   * @type {boolean}
   * @memberof VerifyEmail200Response
   */
  status: boolean
  /**
   *
   * @type {VerifyEmail200ResponseData}
   * @memberof VerifyEmail200Response
   */
  data: VerifyEmail200ResponseData
}

/**
 * Check if a given object implements the VerifyEmail200Response interface.
 */
export function instanceOfVerifyEmail200Response(
  value: object
): value is VerifyEmail200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function VerifyEmail200ResponseFromJSON(
  json: any
): VerifyEmail200Response {
  return VerifyEmail200ResponseFromJSONTyped(json, false)
}

export function VerifyEmail200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): VerifyEmail200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: VerifyEmail200ResponseDataFromJSON(json['data']),
  }
}

export function VerifyEmail200ResponseToJSON(
  value?: VerifyEmail200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: VerifyEmail200ResponseDataToJSON(value['data']),
  }
}
